













































import { Component, Mixins } from 'vue-property-decorator'
import GlobalMixin, { ALERT_TYPE } from '@/mixins/globalMixin'
import { LoginStateModule } from '@/store/modules/LoginStateModule'
import { BadgeStateModule } from '@/store/modules/BadgeStateModule'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import LoginService from '@/service/LoginService'
import BadgeService from '@/service/BadgeService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
  },
})
export default class Login extends Mixins(GlobalMixin) {
  loginService = LoginService.instance
  badgeService = BadgeService.instance

  userId = ""
  password = ""
  isShowPassword = false

  created() {
    /* ログアウト状態に戻す */
    LoginStateModule.logout()
    BadgeStateModule.clearBadge()
  }

  /**
   * ログインボタンのクリック
   */
  onSubmit(event: Event) {
    if ((this.$refs.observer as Vue & { validate: () => boolean }).validate()) {
      this.showLoading()

      this.loginService.login(this.userId, this.password)
        .then(login => {
          if (typeof login === 'string') {
            /* ログインエラー */
            this.alert(login, ALERT_TYPE.ERROR)
            this.hideLoading()
          } else {
            /* ログイン成功 */
            LoginStateModule.login(login)

            /* バッジ情報を取得 */
            this.badgeService.info()
              .then(x => {
                BadgeStateModule.setBadge(x)
              })
              .catch(error => {
                // eslint-disable-next-line
                console.log(error)
              })
            
            setTimeout(() => {
              this.hideLoading()
              const redirectURL = login.firstLogin ? "/member/change_password" : "/member/dashbord"
              this.$router.push(typeof this.$route.query.redirect === "string" ? this.$route.query.redirect : redirectURL)
            }, 1000)
          }
        })
        .catch(error => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("ユーザ名またはパスワードが違います", ALERT_TYPE.ERROR)
          this.hideLoading()
        })
    } else {
      this.hideLoading()
      event.stopPropagation()
    }
  }
}
